import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./tailwind.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import rg4js from "raygun4js";

require("typeface-roboto");
rg4js("apiKey", process.env.REACT_APP_RAYGUN_API_KEY!);
rg4js("enableCrashReporting", true);
rg4js("options", {
  disableAnonymousUserTracking: true,
  excludedHostnames: ["localhost"],
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
